/**
 * 管理端  图表展示
 */
 <template>
    <div class="login-page">
        <topInfo></topInfo>
        <div class="login-title">四川省知识产权发展研究中心专利价值评估系统(管理端)</div>
        <div class="login-title-en">Sichuan Intellectual Property Development Research Center Patent Value Evaluation System</div>
        <!-- 主体内容 -->
        <div class="eval-content">
            <div style="display: flex;justify-content: space-between;">
                <div class="chart-item">
                    <div style="padding: 20px;">
                        <div style="display: flex;">
                            <div style="display: flex;">
                                <div style="width: 10px;height: 24px;background-color: #2a91dd;border-radius: 4px;margin: 0px 10px;"></div>
                                <div>领域分布</div>
                            </div>
                            <div style="margin-left: auto;margin-right: 10px;">
                                <!-- <div style="margin-left: auto;margin-right: 10px;">日期选择</div> -->
                                <!-- <div style="display: flex;">
                                </div> -->
                                <div class="areaPicker">
                                    <el-date-picker
                                        v-model="areaDate"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="开始"
                                        end-placeholder="结束"
                                        format="yyyy.MM.dd"
                                        value-format="yyyy-MM-dd"
                                        @change="areaDateChange()">
                                    </el-date-picker>
                                </div>
                            </div>
                        </div>
                        <div style="margin: 26px;">
                            <div v-show="areaEchart" id="areaEcharts" style="width: 300px;height: 300px;"></div>
                            <div v-if="!areaEchart" style="z-index: 999;margin-top: 150px;color: #999999;">暂无数据</div>
                        </div>
                    </div>
                </div>
                <div class="chart-item">
                    <div style="padding: 20px;">
                        <div style="display: flex;">
                            <div style="display: flex;">
                                <div style="width: 10px;height: 24px;background-color: #2a91dd;border-radius: 4px;margin: 0px 10px;"></div>
                                <div>级别分布</div>
                            </div>
                            <div style="margin-left: auto;margin-right: 10px;">
                                <div class="areaPicker">
                                    <el-date-picker
                                        v-model="levelDate"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="开始"
                                        end-placeholder="结束"
                                        format="yyyy.MM.dd"
                                        value-format="yyyy-MM-dd"
                                        @change="levelDateChange()">
                                    </el-date-picker>
                                </div>
                            </div>
                        </div>
                        <div style="margin: 26px;">
                            <div v-show="levelEchart" id="levelEcharts" style="width: 300px;height: 300px;"></div>
                            <div v-if="!levelEchart" style="z-index: 999;margin-top: 150px;color: #999999;">暂无数据</div>
                        </div>
                    </div>
                </div>
                <div class="chart-item">
                    <div style="padding: 20px 0px;">
                        <div style="display: flex;">
                            <div style="display: flex;">
                                <div style="width: 10px;height: 24px;background-color: #2a91dd;border-radius: 4px;margin: 0px 10px;margin-left: 30px;"></div>
                                <div>评估数量</div>
                            </div>
                            <div style="margin-left: auto;margin-right: 10px;display: flex;">
                                <div style="font-size: 14px;line-height: 24px;color: #606266;margin-right: 4px;">年份</div>
                                <div class="evalNumYearSelect">
                                    <el-select v-model="evalNumYear" @change="evalNumChange()">
                                        <el-option
                                            v-for="item in evalYearData"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <div style="margin: 26px 10px;">
                            <div v-show="evalNumEchart" id="evalNumEcharts" style="width: 360px;height: 300px;"></div>
                            <div v-if="!evalNumEchart" style="z-index: 999;margin-top: 150px;color: #999999;">暂无数据</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex;justify-content: space-between;margin-top: 30px;">
                <div class="chart-item">
                    <div style="padding: 20px 0px;">
                        <div style="display: flex;">
                            <div style="display: flex;">
                                <div style="width: 10px;height: 24px;background-color: #2a91dd;border-radius: 4px;margin: 0px 10px;margin-left: 30px;"></div>
                                <div>价值区间</div>
                            </div>
                            <div style="margin-left: auto;margin-right: 10px;display: flex;">
                                <div style="font-size: 14px;line-height: 24px;color: #606266;margin-right: 4px;">年份</div>
                                <div class="evalNumYearSelect">
                                    <el-select v-model="evalTypeYear" @change="evalTypeChange()">
                                        <el-option
                                            v-for="item in evalYearData"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <div style="margin: 26px 10px;">
                            <div v-show="evalTypeEchart" id="evalTypeEcharts" style="width: 360px;height: 300px;"></div>
                            <div v-if="!evalTypeEchart" style="z-index: 999;margin-top: 150px;color: #999999;">暂无数据</div>
                        </div>
                    </div>
                </div>
                <div class="chart-item">
                    <div style="padding: 20px;">
                        <div style="display: flex;">
                            <div style="display: flex;">
                                <div style="width: 10px;height: 24px;background-color: #2a91dd;border-radius: 4px;margin: 0px 10px;"></div>
                                <div>用户排行</div>
                            </div>
                            <div style="margin-left: auto;margin-right: 10px;">
                                <div class="areaPicker">
                                    <el-date-picker
                                        v-model="customerRankDate"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="开始"
                                        end-placeholder="结束"
                                        format="yyyy.MM.dd"
                                        value-format="yyyy-MM-dd"
                                        @change="cusRankDateChange()">
                                    </el-date-picker>
                                </div>
                            </div>
                        </div>
                        <div style="margin: 26px;" class="eval-table">
                            <el-table size="small" :data="customerRankData" highlight-current-row border element-loading-text="拼命加载中" max-height="280" style="width: 100%;">
                                <el-table-column align="center" type="index" label="序号" width="50">
                                </el-table-column>
                                <el-table-column prop="name" align="center" label="姓名" width="60" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="company" align="center" label="单位" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="num" align="center" label="案件量" width="60" show-overflow-tooltip>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="chart-item">
                    <div style="padding: 20px;">
                        <div style="display: flex;">
                            <div style="display: flex;">
                                <div style="width: 10px;height: 24px;background-color: #2a91dd;border-radius: 4px;margin: 0px 10px;"></div>
                                <div>专利权人</div>
                            </div>
                            <div style="margin-left: auto;margin-right: 10px;">
                                <div class="areaPicker">
                                    <el-date-picker
                                        v-model="agentRankDate"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="开始"
                                        end-placeholder="结束"
                                        format="yyyy.MM.dd"
                                        value-format="yyyy-MM-dd"
                                        @change="agentRankDateChange()">
                                    </el-date-picker>
                                </div>
                            </div>
                        </div>
                        <div style="margin: 26px;" class="eval-table">
                            <el-table  size="small" :data="agentRankData" highlight-current-row border element-loading-text="拼命加载中" max-height="280" style="width: 100%;">
                                <el-table-column align="center" type="index" label="序号" width="50">
                                </el-table-column>
                                <el-table-column prop="name" align="center" label="专利权人" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="num" align="center" label="案件量" width="60" show-overflow-tooltip>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </template>
<script>
   import { 
      getSysAdminAreaData,
      getSysAdminLevelData,
      getSysAdminEvalNumData,
      getSysAdminEvalTypeData,
      getCustomerRankData,
      getAgentRankData,
      webUrl,
      getSelectYearData
   } from '../../api/evalMG'
   import topInfo from '../../components/topInfo'
   import sysNav from '../../components/sysNav'
   import echarts from 'echarts'
   import { checkLogin } from '../../utils/util'
   export default {
    data() {
        return {
            areaEchart: null,
            levelEchart: null,
            evalNumEchart: null,
            evalTypeEchart: null,
            evalNumYear: '',
            evalTypeYear: '',
            areaDate: [],
            levelDate: [],
            customerRankDate: [],
            agentRankDate: [],
            currentDate: '',
            evalYearData: [],
            // 用户排行数据
            customerRankData: [],
            // 专家排行数据
            agentRankData: [],
        }
    },
    // 注册组件
    components: {
        topInfo,
        sysNav
    },
    created(){
        this.getYearData()
        this.getCurrentYearAndDate()
    },
    mounted(){
        this.initAreaChart()
        this.initLevelChart()
        this.initEvalNumChart()
        this.initEvalTypeChart()
        this.initCustomerRank()
        this.initAgentRank()
    },
    methods: { 
        // 初始化领域分布图
        initAreaChart(){
            let date = this.areaDate
            let areaData = []
            let param = {
                startDate: date[0],
                endDate: date[1]
            }
            this.areaEchart = echarts.init(document.getElementById('areaEcharts'));
            getSysAdminAreaData(param)
            .then(res=>{
                if(res.code == 200){
                    areaData = res.data
                    if(areaData&&areaData.length > 0){
                        // 指定图表的配置项和数据
                        let option = {
                            title: {
                                text: '',
                                subtext: '',
                                left: 'center'
                            },
                            // label: {
                            //     show: true,
                            //     position: 'outside',
                            // },
                            tooltip: {
                                trigger: 'item'
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'pie',
                                    radius: '45%',
                                    data: areaData,
                                }
                            ]
                        };
                        // 使用刚指定的配置项和数据显示图表
                        this.areaEchart.setOption(option); 
                    }else{
                        this.areaEchart = false
                    }
                }else{
                    this.areaEchart = false
                }
            })
            
        },
        // 初始化级别分布图
        initLevelChart(){
            let date = this.levelDate
            let levelData = []
            let param = {
                startDate: date[0],
                endDate: date[1]
            }
            this.levelEchart = echarts.init(document.getElementById('levelEcharts'));
            getSysAdminLevelData(param)
            .then(res=>{
                if(res.code == 200){
                    levelData = res.data
                    if(levelData&&levelData.length > 0){
                        // 指定图表的配置项和数据
                        let option = {
                        title: {
                            text: '',
                            subtext: '',
                            left: 'center'
                        },
                        tooltip: {
                            trigger: 'item'
                        },
                        series: [
                            {
                                type: 'pie',
                                radius: '56%',
                                data: levelData,
                            }
                        ]
                        };
                         // 使用刚指定的配置项和数据显示图表
                        this.levelEchart.setOption(option);
                    }else{
                        this.levelEchart = false
                    }
                }else{
                    this.levelEchart = false
                }
            })
        },
        // 初始化评估量展示图
        initEvalNumChart(){
            let year = this.evalNumYear
            let evalNumData = []
            let param = {
                year: year
            }
            this.evalNumEchart = echarts.init(document.getElementById('evalNumEcharts'));
            getSysAdminEvalNumData(param)
            .then(res=>{
                if(res.code == 200){
                    evalNumData = res.data
                    if(evalNumData&&evalNumData.length > 0){
                        let option = {
                            tooltip: {
                                trigger: 'item',
                                formatter: '{b}月: {c}件'
                            },
                            xAxis: {
                                type: 'category',
                                data: ['1', '2', '3', '4', '5', '6', '7','8','9','10','11','12'],
                                axisLine: {
                                    lineStyle: {
                                        color: '#999999'
                                    }
                                }
                            },
                            yAxis: {
                                type: 'value',
                                axisLine: {
                                    lineStyle: {
                                        color: '#999999'
                                    }
                                }
                            },
                            series: [
                                {
                                    data: evalNumData,
                                    type: 'line',
                                    lineStyle: {
                                        color: '#2A91DD'
                                    },
                                    itemStyle: {
                                        color: '#2A91DD'
                                    }
                                }
                            ],
                        };
                        this.evalNumEchart.setOption(option);
                    }else{
                        this.evalNumEchart = false
                    }
                }else{
                    this.evalNumEchart = false
                }
            })
        },
        // 初始化评估方式展示图
        initEvalTypeChart(){
            let year = this.evalTypeYear
            let evalTypeData = []
            let param = {
                year: year
            }
            this.evalTypeEchart = echarts.init(document.getElementById('evalTypeEcharts'));
            getSysAdminEvalTypeData(param)
            .then(res=>{
                if(res.code == 200){
                    evalTypeData = res.data
                    if(evalTypeData&&evalTypeData.dataOne){
                        let option = {
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow'
                                },
                            },
                            legend: {},
                            grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '3%',
                                containLabel: true
                            },
                            xAxis: [
                                {
                                    type: 'category',
                                    data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
                                    axisLine: {
                                        lineStyle: {
                                            color: '#999999'
                                        }
                                    },
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value',
                                    axisLine: {
                                        lineStyle: {
                                            color: '#999999'
                                        }
                                    }
                                }
                            ],
                            series: [
                                {
                                    name: '智能评测',
                                    type: 'bar',
                                    stack: 'Ad',
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    data: evalTypeData.dataOne,
                                    barWidth: 12,
                                    itemStyle: {
                                        color: '#73c0de'
                                    }
                                },
                                {
                                    name: '专家评测',
                                    type: 'bar',
                                    stack: 'Ad',
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    data: evalTypeData.dataTwo,
                                    barWidth: 12,
                                    itemStyle: {
                                        color: '#91cc75'
                                    }
                                },
                            ]
                        }
                        this.evalTypeEchart.setOption(option);
                    }else{
                        this.evalTypeEchart = false
                    }
                }else{
                    this.evalTypeEchart = false
                }
            })
        },
        // 初始化用户排行图
        initCustomerRank(){
            let date = this.customerRankDate
            let param = {
                startDate: date[0],
                endDate: date[1]
            }
            getCustomerRankData(param)
            .then(res=>{
                if(res.code == 200){
                    this.customerRankData = res.data
                }
            })
        },
        // 初始化专家排行图
        initAgentRank(){
            let date = this.agentRankDate
            let param = {
                startDate: date[0],
                endDate: date[1]
            }
            getAgentRankData(param)
            .then(res=>{
                if(res.code == 200){
                    this.agentRankData = res.data
                }
            })
        },
        // 领域分布日期发生改变
        areaDateChange(){
            this.initAreaChart()
        },
        // 级别分布日期发生变化
        levelDateChange(){
            this.initLevelChart()
        },
        // 评测数量年份发生变化
        evalNumChange(){
            this.initEvalNumChart()
        },
        // 评测方式年份发生变化
        evalTypeChange(){
            this.initEvalTypeChart()
        },
        // 用户排行日期发生变化
        cusRankDateChange(){
            this.initCustomerRank()
        },
        // 用户排行日期发生变化
        agentRankDateChange(){
            this.initAgentRank()
        },
        // 获取当前年份和日期
        getCurrentYearAndDate(){
            let date = new Date()
            let year = date.getFullYear()
            let Y = date.getFullYear() + '-'
            let M =
                (date.getMonth() + 1 < 10 ?
                    '0' + (date.getMonth() + 1) :
                    date.getMonth() + 1) + '-'
            let D =
                (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            let currentDate = Y + M + D
            this.evalNumYear = year
            this.evalTypeYear = year
            this.areaDate = [currentDate,currentDate]
            this.levelDate = [currentDate,currentDate]
            this.customerRankDate = [currentDate,currentDate]
            this.agentRankDate = [currentDate,currentDate]
        },
        // 获取可选年份
        getYearData(){
            let param = {}
            getSelectYearData(param)
            .then(res=>{
                res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
                if(res.code == 200){
                    this.evalYearData = res.data
                }
            })
        }
    },
   }
</script>
<style scoped>
.login-page {
    text-align: center;
  }
.login-title {
    font-size: 36px;
    font-weight: 700;
    padding-top: 24px;
  }
.login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
.eval-content {
   width: 1200px;
   margin: 30px auto;
  }
.chart-item {
    width: 380px;
    height: 400px;
    background-color: #fff;
    border-radius: 10px;
}
.evalNumYearSelect>>>.el-select {
    width: 80px !important;
    margin-top: -4px !important;
    height: 30px !important;
}
.evalNumYearSelect>>>.el-input__inner{
    height: 30px !important;
    line-height: 30px !important;
}
.evalNumYearSelect>>>.el-input__icon{
    height: 30px !important;
    line-height: 30px !important;
}
.eval-table>>>.el-table__header th {
    background-color: #2A91DD !important;
}
.eval-table>>>.el-table thead {
    color: #FFFFFF !important;
}
.areaPicker>>>.el-input__inner {
    width: 210px !important;
    height: 30px !important;
    line-height: 30px !important;
    margin-top: -4px !important;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    padding-left: 20px !important;
    padding-right: 0px !important;
}
.areaPicker>>>i {
    display: none !important;
}
.areaPicker>>>.el-date-editor .el-range-separator {
    line-height: 20px !important;
    color: #999999 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/system/platformChart.vue